import { SVGProps } from 'react';

export const DownloadIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.9936 7.86862L12.7563 6.63138L9.87497 9.51275V0.25H8.12497V9.51275L5.2436 6.63138L4.00635 7.86862L8.99997 12.8622L13.9936 7.86862Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.25 14.25V16H3.75V14.25H2V16C2 16.9651 2.78487 17.75 3.75 17.75H14.25C15.2151 17.75 16 16.9651 16 16V14.25H14.25Z"
        fill="currentColor"
      />
    </svg>
  );
};
